import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/dist/styles.css";
import "./ChatImage.css"
import Captions from "yet-another-react-lightbox/dist/plugins/captions";
import "yet-another-react-lightbox/dist/plugins/captions/captions.css";
export default function ChatImage({ content }) {
  const [visible, setVisible] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const [closeOnBackdropClick, setCloseOnBackdropClick] = useState(true);

  const regexImg = /<img[^>]*src="([^"]+)"[^>]*>/g;

  const parts = [];
  let lastIndex = 0;
  let match;

  // decouper le contenu en texte / images dans l'ordre
  while ((match = regexImg.exec(content)) !== null) {

    if (match.index > lastIndex) {
      parts.push({ type: "text", content: content.slice(lastIndex, match.index) });
    }

    parts.push({ type: "image", src: match[1], content: match[0] });
    lastIndex = regexImg.lastIndex;
  }

  // on rajoute le text apres l'image s'il y en a 
  if (lastIndex < content.length) {
    parts.push({ type: "text", content: content.slice(lastIndex) });
  }
  const contentText = parts.filter((p) => p.type === "text").map((p) => p.content).join(" ");
  const slides = parts.filter((p) => p.type === "image").map((p) => ({
      src: p.src,
      description: contentText
      
    }));

  return (
    <div>
      {parts.map((p, i) => {
        if (p.type === "text") return <span key={i}>{p.content}</span>;
        return (
          <img key={i} src={p.src} alt="chat-img" style={{ maxWidth: "150px", cursor: "pointer", borderRadius: "8px", margin: "0 4px" }}
            onClick={() => {
              setStartIndex(slides.findIndex((s) => s.src === p.src));
              setVisible(true);
            }}
          />
        );
      })}

      <Lightbox open={visible} close={() => setVisible(false)} slides={slides} index={startIndex} controller={ {closeOnBackdropClick,closeOnBackdropClick}}
      plugins={[Captions]}   
      captions={{
        descriptionTextAlign: "center",
        descriptionMaxLines: 10,
        showToggle: false              
      }}       
      render={{
        buttonPrev: slides.length > 1 ? undefined : () => null,
        buttonNext: slides.length > 1 ? undefined : () => null,
      }}
      />
    </div>
  );
}
